<template>
  <el-tooltip class="item" effect="dark" content="输入数字时按ID查询，否则按名称查询" placement="top">
    <el-select
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            default-first-option
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入商户名称/ID"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
    import { Message, MessageBox } from 'element-ui'
    import { getBusinessList } from '@/service/broker'
    // 目前不支持多选
    export default{
        props: {
            value: [Number, String],
            initChooseFirst: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null
            }
        },
        created() {
            this.search(this.value, true)
        },
        watch: {
            value(val) {
                if (val !== this.data) {
                    this.search(val)
                }
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                let conditions = {}
                if (!!query) {
                    conditions.name = query
                }
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    getBusinessList(conditions).then(response => {
                        that.loading = false
                        that.options = response.data
                        that.data = null
                        if (response.data.length > 0) {
                            if (!!that.value) {
                                that.options.forEach(item => {
                                    if (item.id === that.value) {
                                        that.data = that.value
                                    }
                                })
                            } else if (that.initChooseFirst) {
                                that.data = response[0].id
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
            },
            onClean() {
                // this.options = []
                this.data = null
                this.$emit('input', '')
            }
        }
    }
</script>
